let React = require("react");
const { Route, Switch, Redirect } = require('react-router-dom')
const { canUseDOM } = require('fbjs/lib/ExecutionEnvironment')
let Application    = require("../Application.js");
let Utilities    = require("../util/Utilities.js");
var ApplicationContext = require("../config/ApplicationContext.js");

let Home           = require("./Home.jsx");
let LibraryVersion = require("./LibraryVersion.jsx");
let Explore        = require("./Explore.jsx");
let Search         = require("./Search.jsx");
let Updates        = require("./Updates.jsx");
let PageNotFound   = require("./PageNotFound.jsx");
let CheckLoginSuccess = require("./CheckLoginSuccess.jsx");
let InvitationNoPending = require("./InvitationNoPending.jsx");
let InvitedAccountMismatch = require("./InvitedAccountMismatch.jsx");
let SearchPackages = require("./desktop/SearchPackages.jsx");
let DataHubPage    = require("./generic/DataHubPage.jsx");

let LibraryDetail  = require("./LibraryDetail.jsx");
let PackageDetail  = require("./PackageDetail.jsx");
let Model3DDetail  = require("./Model3DDetail.jsx");
let Tables = require("./Tables.jsx")

//overwrite for react router to leave parentheses encoded, otherwise libraries/packages/3dmodels/trash in hub won't be rendered
decodeURI = Utilities.encodeParentheses;

class Router extends React.Component {

    constructor(){
        super();

        this.state = {loginChecked: false, isLogin: false};

        if(canUseDOM){
            this.isModal = this.testModal();
        }
    }

    componentDidMount() {
        this.previousLocation = this.props.location;

        Application.dataStore.getUserInfo(this.props.handleError)
            .then(isLogin => this.setState({loginChecked: true, isLogin}))
            .catch(() => this.setState({loginChecked: true, isLogin: false}));
    }

    componentWillUpdate(nextProps) {
        const { location } = this.props;

        this.isModal = this.testModal();
        if (nextProps.history.action !== "POP" && (!location.state || !location.state.modal)) {
            this.previousLocation = this.props.location;
        }
    }

    testModal(){
        return /(\/libraries|packages|3dmodels|trash|table|newversion\/)/gi.test(window.location.pathname);
    }

    checkLastHubId(props, isLogin){
        let {location} = props;
        let hubId = Utilities.getCookie("lastHubId");

        if(hubId && location.state && location.state.tab){
            return <Redirect to={`/hubs/${hubId}-/${location.state.tab}`}/>
        }else if(hubId){
            return <Redirect to={`/hubs/${hubId}-/libraries`}/>
        }else{
            return <DataHubPage {...props} {...this.props} isLogin={isLogin} />
        }
    }

    render() {
        const { location } = this.props;
        const { loginChecked, isLogin } = this.state;
        const isInternalModal = (location.state && location.state.modal && this.previousLocation !== location);

        if(!loginChecked){ return <div></div>}

        return  <div>
                    <Switch location={isInternalModal ? this.previousLocation : location}>
                        <Route exact path="/" render={props =>
                            isLogin ? <Redirect to="/:idusername/libraries"/> : <Home {...this.props} {...props} />
                        }/>

                        <Route path="/explore" render={props =><Explore {...this.props} {...props} />} />
                        <Route path="/search" render={props =><Search {...this.props} {...props} />} />
                        <Route path="/updates" render={props =><Updates {...this.props} {...props} />} />
                        <Route path="/hubs" render={props => <DataHubPage {...props} {...this.props} isLogin={isLogin} />} />
                        <Route path="/start" render={props => this.checkLastHubId(props, isLogin)} />

                        <Redirect exact from="/libraries" to={{pathname: "/start", state: {tab: "libraries"}}} />
                        <Redirect exact from="/:idusername/libraries" to={{pathname: "/start", state: {tab: "libraries"}}} />
                        <Redirect exact from="/:idusername/manageMembers" to={{pathname: "/start", state: {tab: "manageMembers"}}} />
                        <Redirect exact from="/libraries/library" to="/start" />

                        <Redirect exact from="/packages" to={{pathname: "/start", state: {tab: "packages"}}} />
                        <Redirect exact from="/:idusername/packages" to={{pathname: "/start", state: {tab: "packages"}}} />

                        <Redirect exact from="/3dmodels" to={{pathname: "/start", state: {tab: "3dmodels"}}} />
                        <Redirect exact from="/:idusername/3dmodels" to={{pathname: "/start", state: {tab: "3dmodels"}}} />

                        <Redirect exact from="/trash" to={{pathname: "/start", state: {tab: "trash"}}} />
                        <Redirect exact from="/:idusername/trash" to={{pathname: "/start", state: {tab: "trash"}}} />

                        <Route path="/app/qt-search/:html" component={SearchPackages} />

                        <Route path="/tables" render={props => <Tables {...this.props} {...props} /> }/>

                        <Route path="/exploreTable" render={()=> <div style={{height:"100vh", background: "white"}}>
                                <iframe style={{maxHeight: "100vh", height: "100vh"}}
                                    src={ApplicationContext.assetUrlPrefix+"/assets/tables/exploreTable/index.html"}>
                                </iframe>
                            </div>
                        }/>

                        <Route path="/placePartTable" render={()=> <div style={{height:"100vh", background: "white"}}>
                                <iframe style={{maxHeight: "calc(100vh - 20px)", height: "calc(100vh - 20px)", width: "500px"}}
                                    src={ApplicationContext.assetUrlPrefix+"/assets/tables/placePartTable/index.html"}>
                                </iframe>
                            </div>
                        }/>

                        <Route path="/invitationNoPending" component={InvitationNoPending}/>
                        <Route path="/invitedAccountMismatch" component={InvitedAccountMismatch}/>
                        <Route path="/pageNotFound" component={PageNotFound}/>

                        <Route path="/checkLoginSuccess" component={CheckLoginSuccess}/>

                        {!this.isModal && <Redirect from="" to="/pageNotFound" />}
                    </Switch>

                        <Route exact path="/libraries/:name" render={props => <LibraryDetail {...props} handleError={this.props.handleError} />} location={location} />
                        <Route exact path="/packages/:name" render={props => <PackageDetail {...props} handleError={this.props.handleError} />} location={location} />
                        <Route exact path="/3dmodels/:name" render={props => <Model3DDetail {...props} handleError={this.props.handleError} />} location={location} />
                        <Route exact path="/newversion/:id/:name" render={props => <LibraryVersion {...props} handleError={this.props.handleError} />} location={location}/>
                </div>
    }
}

module.exports = Router;
